import React from "react";
import PosDiscountItems from "../../SalesManagement/Pos/PosDiscountItems";

const PosDiscountModal = ({
  isOpen,
  toggle,
  setDiscountInputValue,
  discountDropdownValue,
  handleSubmitDiscount,
  setIncreaseDiscount,
  setDiscountDropdownValue
}) => {
  // fixed this value for discountIndividual and totalDiscount
  const discountIndividual = true;
  const totalDiscount = false;
  return (
    <>
      <PosDiscountItems
        totalDiscount={totalDiscount}
        discountIndividual={discountIndividual}
        isOpen={isOpen}
        toggle={toggle}
        setDiscountInputValue={setDiscountInputValue}
        discountDropdownValue={discountDropdownValue}
        setDiscountDropdownValue={setDiscountDropdownValue}
        handleSubmitDiscount={handleSubmitDiscount}
        setIncreaseDiscount={setIncreaseDiscount}
      ></PosDiscountItems>
    </>
  );
};

export default PosDiscountModal;
